<template>
  <div>
    <assignment></assignment>
  </div>
</template>

<script>
import * as firebase from "firebase/app";
import "firebase/auth";

import Assignment from "@/components/Assignment.vue";

export default {
  data() {
    return {};
  },
  components: {
    Assignment
  },

  methods: {}
};
</script>

<style scoped>
div {
  color: inherit;
}
</style>